export default __webpack_public_path__ + "static/media/eye.058bb162.svg";